export default __webpack_public_path__ + "static/media/digital_sol.afb3b491.png";